import script from "./group.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.96.1/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./group.vue?vue&type=script&setup=true&lang=js"
export * from "./group.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.96.1/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./group.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__